
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'no-ad-hoc-component',
  templateUrl: './no-ad-hoc.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, TranslateModule]
})
export class NoAdHocComponentComponent {
  readonly onAction = output<{ action: string }>();
  adHocModal(){
    this.onAction.emit({action:"createAdHoc"});
  }

}